import React from "react";

const VehiclePlaceholder = ({ type = "" }) => {
  return type === "driver" ? (
    <div
      className="animated-bg-color"
      style={{ height: 50, borderRadius: 3, paddingTop: 5 }}
    >
      <div className="d-flex bd-highlight">
        <div className="flex-grow-1 bd-highlight">
          <div className="d-flex justify-content-start">
            <div
              className="animated-bg"
              style={{ width: 20, height: 15, borderRadius: 5, margin: 5 }}
            ></div>
            <div
              className="animated-bg"
              style={{
                width: 200,
                height: 15,
                borderRadius: 5,
                margin: 5,
                marginLeft: 10,
              }}
            ></div>
          </div>
        </div>
        <div
          className="animated-bg"
          style={{ width: 100, height: 15, borderRadius: 5, margin: 5 }}
        ></div>
      </div>
      <div
        className="animated-bg"
        style={{ width: "90%", height: 15, borderRadius: 5, margin: 5 }}
      ></div>
    </div>
  ) : type === "poi" ? (
    <div
      className="animated-bg-color"
      style={{ height: 50, borderRadius: 3, paddingTop: 5 }}
    >
      <div className="d-flex bd-highlight">
        <div className="flex-grow-1 bd-highlight">
          <div className="d-flex justify-content-start">
            <div
              className="animated-bg"
              style={{ width: 20, height: 15, borderRadius: 5, margin: 5 }}
            ></div>
            <div
              className="animated-bg"
              style={{
                width: 200,
                height: 15,
                borderRadius: 5,
                margin: 5,
                marginLeft: 10,
              }}
            ></div>
            <div className="d-flex w-full ml-auto">
              <div
                className="animated-bg"
                style={{ width: 20, height: 15, borderRadius: 5, margin: 5 }}
              ></div>
              <div
                className="animated-bg"
                style={{ width: 20, height: 15, borderRadius: 5, margin: 5 }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="animated-bg-color"
      style={{ height: 90, borderRadius: 3, paddingTop: 5 }}
    >
      <div className="d-flex bd-highlight">
        <div className="flex-grow-1 bd-highlight">
          <div className="d-flex justify-content-start">
            <div
              className="animated-bg"
              style={{ width: 20, height: 15, borderRadius: 5, margin: 5 }}
            ></div>
            <div
              className="animated-bg"
              style={{
                width: 200,
                height: 15,
                borderRadius: 5,
                margin: 5,
                marginLeft: 10,
              }}
            ></div>
          </div>
        </div>
        <div
          className="animated-bg"
          style={{ width: 100, height: 15, borderRadius: 5, margin: 5 }}
        ></div>
      </div>

      <div className="d-flex bd-highlight">
        <div className="flex-grow-1 bd-highlight">
          <div className="d-flex justify-content-start">
            <div
              className="animated-bg-gray"
              style={{ width: 150, height: 15, borderRadius: 5, margin: 8 }}
            ></div>
          </div>
        </div>

        <div className="d-flex justify-content-start">
          <div
            className="animated-bg-gray"
            style={{
              width: 20,
              height: 15,
              borderRadius: 2,
              margin: 5,
              marginLeft: 10,
            }}
          ></div>
          <div
            className="animated-bg-gray"
            style={{ width: 20, height: 15, borderRadius: 2, margin: 5 }}
          ></div>
        </div>
      </div>
      <div
        className="animated-bg"
        style={{ width: "90%", height: 15, borderRadius: 5, margin: 5 }}
      ></div>
    </div>
  );
};

export default VehiclePlaceholder;
